/**
 * How often Aria may proactively reach out, in contacts per month. The numbers are the stored value,
 * so they are named rather than inlined at the call site.
 */
export enum CoachContactFrequency {
  NEVER = 0,
  MONTHLY = 1,
  BIWEEKLY = 2,
  WEEKLY = 4
}

/** Used when a user has never chosen: roughly every other week. */
export const DEFAULT_COACH_CONTACT_FREQUENCY = CoachContactFrequency.BIWEEKLY

export const COACH_FREQUENCY_OPTIONS: { value: CoachContactFrequency; labelKey: string }[] = [
  { value: CoachContactFrequency.NEVER, labelKey: 'settings.coach.frequency.never' },
  { value: CoachContactFrequency.MONTHLY, labelKey: 'settings.coach.frequency.monthly' },
  { value: CoachContactFrequency.BIWEEKLY, labelKey: 'settings.coach.frequency.biweekly' },
  { value: CoachContactFrequency.WEEKLY, labelKey: 'settings.coach.frequency.weekly' }
]
